import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ApiRequestService, GoogleTagManagerService } from '@prekog/common-ui';
import { GetSpecialitiesResponse } from './getspecialitiesresponse';
import { Speciality } from './speciality';
import { SpecialityWithPrices } from './specialitywithprices';

@Component({
    selector: 'pf-consultation',
    templateUrl: './consultation.component.html',
    styleUrls: ['./consultation.component.scss'],
    standalone: true,
    imports: [RouterModule, CommonModule]
})
export class ConsultationComponent implements OnInit {
    bookAppointmentsUrl = 'https://medicall.cc/idopontfoglalas/regenero/index';
    chosenSpecialityId = 0;
    getSpecialitiesUrl = '/regenero/get-specialities-description';
    hasSpecialityChosen = false;
    nameOfLink = 'IDŐPONTFOGLALÁS LINK MEGTEKINTÉSE';
    regeneroBaseUrl = '';
    showExamination = false;
    specialities?: Speciality[];

    constructor(
        public router: Router,
        private _apiRequestService: ApiRequestService,
        @Inject('REGENERO_BASE_URL') private _regeneroBaseUrl: string,
        private _googleTagManagerService: GoogleTagManagerService
    ) {
        this.regeneroBaseUrl = _regeneroBaseUrl;
    }

    ngOnInit(): void {
        this._apiRequestService
            .sendRequest<{}, GetSpecialitiesResponse>(this.regeneroBaseUrl, {}, true, this.getSpecialitiesUrl)
            .subscribe((response) => {
                this.specialities = response.specialityList;
            });
    }

    showExaminationElement() {
        this.specialities!.forEach((speciality) => {
            speciality.hasSpecialityChosen = false;
            speciality.isVisible = false;
        });
        this.showExamination = !this.showExamination;
    }

    chooseOneSpeciality(speciality: SpecialityWithPrices) {
        this.chosenSpecialityId = speciality.speciality?.id!;
        speciality.hasSpecialityChosen = !speciality.hasSpecialityChosen;
        speciality.isVisible = !speciality.isVisible;
    }

    settingUpLinkToGoogleAnalytics() {
        this._googleTagManagerService.pushLinkIntoDataLayer(this.nameOfLink, this.bookAppointmentsUrl);
    }
}
